<template>
  <span>Invoice<span class="branding--new-green">1</span><span class="branding--new-green">2</span><span class="branding--new-green">3</span></span>
</template>

<script setup>
</script>
